import { usePortfolioDashboardInputSuspenseQuery } from 'generated/graphql';
import { getSavedDaysRange } from './tiles/PortfolioTilesService';
import { UserSettings } from 'components/management/UserSettings.types';
import { usePortfolioFilters } from 'components/technical/PortfolioFilterDrawer/UsePortfolioFilters';
import ChartsSkeleton from 'components/ChartsSkeleton';
import Loader from 'components/technical/Loader/Loader';
import { Suspense } from 'react';
import PortfolioTiles from './tiles/PortfolioTiles';
import PortfolioSnapshotContainer from './PortfolioSnapshotContainer';
import CardWithFooter from './CardWithFooter';
import { useNavigate } from 'react-router-dom';
import PositionSummaryLight from '../openPositions/PositionSummaryLight';
import PortfolioExposureRisk from './PortfolioExposureRisk';
import { Stack, Typography } from '@mui/joy';

const PortfolioDashboard = () => {
  const { portfolioFilters } = usePortfolioFilters();
  const { data, refetch } = usePortfolioDashboardInputSuspenseQuery({
    variables: { subAccountAssetFilters: portfolioFilters, tilesSettings: UserSettings.TilesDateRange },
  });
  const navigate = useNavigate();

  const { savedDateRange, savedTimeFrameInDays } = getSavedDaysRange(data);

  if (data.portfolio.accounts.length === 0) {
    return (
      <ChartsSkeleton titleLeft="Balance & Exposure" titleRight="Risk Breakdown" onSubAccountConnected={refetch} />
    );
  }

  return (
    <>
      <Suspense fallback={<Loader appearance="inline" />}>
        <PortfolioTiles savedDateRange={savedDateRange} savedTimeFrameInDays={savedTimeFrameInDays} />
      </Suspense>

      <Suspense fallback={<Loader appearance="inline" />}>
        <PortfolioSnapshotContainer />
      </Suspense>

      <CardWithFooter noMinHeight seeMoreAction={() => navigate('/app/portfolio/positions')}>
        <Suspense fallback={<Loader appearance="inline" />}>
          <Stack gap={2} height="100%">
            <Typography level="h3">Open positions</Typography>
            <PositionSummaryLight portfolio={data.portfolio} />
          </Stack>
        </Suspense>
      </CardWithFooter>

      <Suspense fallback={<Loader appearance="inline" />}>
        <PortfolioExposureRisk assets={data.assets.feature} />
      </Suspense>
    </>
  );
};

export default PortfolioDashboard;
